import { render, staticRenderFns } from "./SearchDoctorInput.vue?vue&type=template&id=adbdfbfe&"
import script from "./SearchDoctorInput.vue?vue&type=script&lang=js&"
export * from "./SearchDoctorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
})
